import { ElUploadInternalFileDetail } from 'element-ui/types/upload';
import _ from 'lodash';
import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import { E取込分類, E取込形式 } from '@/openapi/enum';
import { 計画書データApi, 計画書データListItemResponse } from '@/openapi/user';

import C変換枚数 from '@/components/取込/変換枚数/変換枚数.vue';

import 取込DialogMixin from '@/entries/user/mixins/取込DialogMixin';
import 取込Mixin from '@/entries/user/mixins/取込Mixin';
import 変換枚数Mixin from '@/entries/user/mixins/変換枚数Mixin';
import 計画書Mixin from '@/entries/user/mixins/計画書Mixin';
import EventObserverMixin from '@/mixins/EventObserverMixin';

import UserApiUtility from '@/classes/common/UserApiUtility';
import 決算期Utility from '@/classes/common/決算期Utility';

export default mixins(変換枚数Mixin, 取込Mixin, 取込DialogMixin, 計画書Mixin, EventObserverMixin).extend({
  name: 'C差異分析Header',

  components: {
    C変換枚数,
  },

  props: {
    取込分類: {
      type: Number as PropType<E取込分類>,
      required: true,
    },
    部門pk: {
      type: Number,
    },
    canImport: {
      type: Boolean,
      default: true,
    },
  },

  data(): {
    会計期間Options: {
      label: string;
      value: number;
    }[];
    v会計期間: number;
    e取込形式: typeof E取込形式;
    v取込形式: E取込形式;
  } {
    return {
      会計期間Options: [],
      v会計期間: 0,
      e取込形式: E取込形式,
      v取込形式: E取込形式.pdf,
    };
  },

  created() {
    const v決算期 = 決算期Utility.getモニタリング会計期間();
    const m = String(v決算期.fixMonth).padStart(2, '0');
    this.会計期間Options = v決算期.header.map((h) => ({
      label: h.label,
      value: Number(h.year + m),
    }));
    this.v会計期間 = this.モニタリング会計期間;
  },

  methods: {
    async onChange会計期間(): Promise<void> {
      const body = {
        cモニタリング会計期間: this.v会計期間,
      };
      await UserApiUtility.ogApi(計画書データApi).updateモニタリング会計期間(this.計画書.pk, body);

      const v計画書: 計画書データListItemResponse = {
        ..._.cloneDeep(this.計画書),
        ...body,
      };
      this.post計画書ToParentTab(v計画書);
      this.$emit('change会計期間');
    },
    openFileSelectionDialog(): void {
      this.setImportInfo(this.v取込形式, this.取込分類, this.モニタリング会計期間Year, this.部門pk);
    },
    selectFile(file: ElUploadInternalFileDetail): void {
      if (!this.selectImportFile(this.v取込形式, file)) return;

      this.openFirstDialog();
    },
    async loadPdf(): Promise<void> {
      await this.load変換枚数();
      this.publishEvent();
    },
  },
});
